import React, { useState } from "react";
import "./Calendar.scss";
import DatePicker from "react-datepicker";

const Calendar = (props) => {
  const [internalDate, setInternalDate] = useState(null);
  const selectedDate =
    props.selected !== undefined ? props.selected : internalDate;

  const handleChange = (date) => {
    if (props.selected === undefined) {
      setInternalDate(date);
    }

    props.onChange?.(date);
  };

  return (
    <div className="date">
      <DatePicker
        selected={selectedDate}
        onChange={handleChange}
        placeholderText={props.birthdatePlaceHolder}
        dateFormat="dd-MM-yyyy"
        maxDate={new Date()}
      />
      <i className="icon-mail iconCalendar"></i>
    </div>
  );
};

export default Calendar;
